export const APP_KEY_ACCESS = {
  defaultKey: "FREE",
  activeStatus: 1,
};

export const APP_KEY_ACCESS_MESSAGES = {
  blocked: "Ứng dụng chưa được kích hoạt cho shortcode này hoặc key không hợp lệ.",
  requestFailed: "Không thể xác thực key ứng dụng. Vui lòng thử lại sau.",
};
